
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import "./CompanyFAQs.css";
import AskFaq from "../../../Images/askFaq.png";
import React, { useState, useEffect, useRef, useContext, useImperativeHandle } from "react";
import { useLocation, useParams } from "react-router-dom";
import { format, parseISO } from 'date-fns';
import URLstateContext from "../../../provider/CommonContext";

function Faq(props, ref) {
  let getExchange = props.exchange;
  let getCoCode = props.coCode;
  let getCompName = props.compname;
  let getInstr = props.valueInstr;
  let getExchangeNew = props.ExchangeNSE;
  if (getExchange == "") { getExchange = "NSE"; }
  const { BaseURL } = useContext(URLstateContext);
  const [data, setData] = useState([]);
  const [type, settype] = useState(['C']);
  const [dataCompanyName, setdataCompanyName] = useState([]);
  const [compname, setcompname] = useState([]);
  const [co_code, setco_code] = useState([]);
  const { exchg, cocode, requestcompname } = useParams();
  let getData;

  useEffect(() => {
    const getUrl = BaseURL + "FAQ";
    if (props.coCode != "") {
      if (getExchangeNew != "" && getExchangeNew === "NSE") {
        fetch(`${getUrl}/${getCoCode}/NSE`)
          .then((response) => response.json())
          .then((data) => {
            getData = data.data;
            setData(getData);
            //console.log("getData", getData)
          })
          .catch((error) => {
            //console.log("not found the api");
          });
      } else {
        fetch(`${getUrl}/${getCoCode}/BSE`)
          .then((response) => response.json())
          .then((data) => {
            getData = data.data;
            setData(getData);
            //console.log("getData", getData)
          })
          .catch((error) => {
            //console.log("not found the api");
          });
      }
    }
  }, [props.coCode]);



  return (
    <>
      <section className="faq-block">
        <Container className="table-boxFaq">
          <Row>
            <div className="FaqDiv">
              <div>
                <h3>Frequently Asked Questions</h3>
              </div>
              <div className="faq-betaComp">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </div>
            {data != null && data.map((eachData) => (
              <Col md={11}>
                {(getInstr === "futures") ?
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Q1.What is {getCompName} Options In & Out the Money Open Interest ?</Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          Options traders are known to get useful insights like liquidity, depth, premiums, maturity date, and more from Option Chain. Moneysukh makes it possible for you trade {getCompName} options directly from Option Chain.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Q2.Can I View  {getCompName} Options Strike Price on Option Chain?</Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          Yes, you can view the strike price for  {getCompName} by using the Option Chain on Moneysukh. Strike price refers to the set cost at which you can trade an options contract in the options.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>Q3.Where to Find Advanced Option Chain for Options Trading ?</Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          Options traders can access Advanced Option Chain on Moneysukh using web or mobile platforms. The Advanced Option Chain allows you to access comprehensive details about OI Analysis, Volumes, PCRs  and more.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  : (getExchangeNew === "NSE") ? <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Q1.What is {getCompName} Share Price ?</Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          {getCompName} share price is ₹ {(eachData.nsePrice != null) ? eachData.nsePrice.toFixed(2) : ''} As on &nbsp;{(eachData.Tr_date != null) ? format(parseISO(eachData.Tr_date), 'dd MMM, yyyy') : ''} &nbsp; | &nbsp;{(eachData.Tr_date != null) ? (eachData.Tr_date.split("T")[1] !== "00:00:00") ? eachData.Tr_date.split("T")[1] : 'EOD' : ''}
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Q2. What is the Market Cap of {getCompName} ?</Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          The Market Cap of {getCompName} is ₹ {(eachData.mcap != null) ? eachData.mcap.toFixed(2) : ''} Cr As on &nbsp;{(eachData.Tr_date != null) ? format(parseISO(eachData.Tr_date), 'dd MMM, yyyy') : ""} &nbsp; | &nbsp;{(eachData.Tr_date != null) ? (eachData.Tr_date.split("T")[1] !== "00:00:00") ? eachData.Tr_date.split("T")[1] : 'EOD' : ''}
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>Q3. What is the P/E ratio of {getCompName} ?</Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          The P/E ratio of {getCompName} is {(eachData.PE_TTM != null) ? eachData.PE_TTM.toFixed(2) : ''} As on &nbsp;{(eachData.Tr_date != null) ? format(parseISO(eachData.Tr_date), 'dd MMM, yyyy') : ''} &nbsp; | &nbsp;{(eachData.Tr_date != null) ? (eachData.Tr_date.split("T")[1] !== "00:00:00") ? eachData.Tr_date.split("T")[1] : 'EOD' : ''}
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header> Q4. What is the PB ratio of {getCompName} ? </Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          The PB ratio of {getCompName} is {(eachData.PB_TTM != null) ? eachData.PB_TTM.toFixed(2) : ''} As on &nbsp;{(eachData.Tr_date != null) ? format(parseISO(eachData.Tr_date), 'dd MMM, yyyy') : ''} &nbsp; | &nbsp;{(eachData.Tr_date != null) ? (eachData.Tr_date.split("T")[1] !== "00:00:00") ? eachData.Tr_date.split("T")[1] : 'EOD' : ''}
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>Q5. What is the CAGR of {getCompName} ? </Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          The 5 Years CAGR of {getCompName} is {(eachData.R5YearRet_CAGR != null) ? eachData.R5YearRet_CAGR.toFixed(2) : ''}%, 3 Years is {(eachData.R3YearRet_CAGR != null) ? eachData.R3YearRet_CAGR.toFixed(2) : ''}%  and 1 Year is {(eachData.R1YearRet != null) ? eachData.R1YearRet.toFixed(2) : ''}%.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>Q6. What is the total asset of {getCompName} ? </Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          {getCompName} total asset stands at INR {(eachData.ReportedTotalAssets != null) ? eachData.ReportedTotalAssets.toFixed(2) : ''} crore.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                      <Accordion.Header>Q7. Is it a good time to buy {getCompName} share? </Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          {getCompName} has a trailing 12-month operating revenue of INR  {(eachData.TotalRevenue != null) ? eachData.TotalRevenue.toFixed(2) : ''} Cr. An annual revenue de-growth of {(eachData.Revenue_Growth != null) ? eachData.Revenue_Growth.toFixed(2) : ''}% requires improvement. A pre-tax margin of {(eachData.PreTaxMargin != null) ? eachData.PreTaxMargin.toFixed(2) : ''}% is healthy, and an ROE of {(eachData.ROE_TTM != null) ? eachData.ROE_TTM.toFixed(2) : ''}% is adequate but could be improved. {getCompName} has a reasonable debt-to-equity ratio of {(eachData.DebttoEquity != null) ? eachData.DebttoEquity.toFixed(2) : ''}%, indicating a healthy balance sheet.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7">
                      <Accordion.Header>Q8. How to check corporate action in {getCompName} ? </Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          Any one can directly search through Moneysukh. Just type “{getCompName}” in search bar on the top and you will find all the details.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="8">
                      <Accordion.Header>Q9. What is the 52 Week High and Low of {getCompName}? </Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          52 Week High of {getCompName} is {(eachData.NSE_high52wk != null) ? eachData.NSE_high52wk.toFixed(2) : ''} and Low is {(eachData.NSE_low52wk != null) ? eachData.NSE_low52wk.toFixed(2) : ''}.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="9">
                      <Accordion.Header>Q10. How to check the open price and close price of {getCompName} ? </Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          Click on the search box and type the name of the stock you want to search. Select the stock you wish to check. Once you click on the stock name, you will see "Markets" page on your screen. On the top, just above the price chart you will get the {getCompName} High, Low, Open Price and Previous Close Price.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="10">
                      <Accordion.Header>Q11. How to check {getCompName} financial statements and cashflow detailed information? </Accordion.Header>
                      <Accordion.Body className="textjustify">
                        <p>
                          In the “ Market” tab section there are two scroll tabs. Click first tab and select “ company profile”. Now enter company name and select the information required.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                    : <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>Q1.What is {getCompName} Share Price ?</Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            {getCompName} share price is ₹ {(eachData.bsePrice != null) ? eachData.bsePrice.toFixed(2) : ''} As on &nbsp;{(eachData.upd_time != null) ? format(parseISO(eachData.upd_time), 'dd MMM, yyyy') : ''} &nbsp; | &nbsp;{(eachData.upd_time != null) ? (eachData.upd_time.split("T")[1] !== "00:00:00") ? eachData.upd_time.split("T")[1] : 'EOD' : ''}
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1">
                        <Accordion.Header>Q2. What is the Market Cap of {getCompName} ?</Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            The Market Cap of {getCompName} is ₹ {(eachData.mcap != null) ? eachData.mcap.toFixed(2) : ''} Cr As on &nbsp;{(eachData.upd_time != null) ? format(parseISO(eachData.upd_time), 'dd MMM, yyyy') : ""} &nbsp; | &nbsp;{(eachData.upd_time != null) ? (eachData.upd_time.split("T")[1] !== "00:00:00") ? eachData.upd_time.split("T")[1] : 'EOD' : ''}
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="2">
                        <Accordion.Header>Q3. What is the P/E ratio of {getCompName} ?</Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            The P/E ratio of {getCompName} is {(eachData.PE_TTM != null) ? eachData.PE_TTM.toFixed(2) : ''} As on &nbsp;{(eachData.upd_time != null) ? format(parseISO(eachData.upd_time), 'dd MMM, yyyy') : ''} &nbsp; | &nbsp;{(eachData.upd_time != null) ? (eachData.upd_time.split("T")[1] !== "00:00:00") ? eachData.upd_time.split("T")[1] : 'EOD' : ''}
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="3">
                        <Accordion.Header> Q4. What is the PB ratio of {getCompName} ? </Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            The PB ratio of {getCompName} is {(eachData.PB_TTM != null) ? eachData.PB_TTM.toFixed(2) : ''} As on &nbsp;{(eachData.upd_time != null) ? format(parseISO(eachData.upd_time), 'dd MMM, yyyy') : ''} &nbsp; | &nbsp;{(eachData.upd_time != null) ? (eachData.upd_time.split("T")[1] !== "00:00:00") ? eachData.upd_time.split("T")[1] : 'EOD' : ''}
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="4">
                        <Accordion.Header>Q5. What is the CAGR of {getCompName} ? </Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            The 5 Years CAGR of {getCompName} is {(eachData.R5YearRet_CAGR != null) ? eachData.R5YearRet_CAGR.toFixed(2) : ''}%, 3 Years is {(eachData.R3YearRet_CAGR != null) ? eachData.R3YearRet_CAGR.toFixed(2) : ''}%  and 1 Year is {(eachData.R1YearRet != null) ? eachData.R1YearRet.toFixed(2) : ''}%.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="5">
                        <Accordion.Header>Q6. What is the total asset of {getCompName} ? </Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            {getCompName} total asset stands at INR {(eachData.ReportedTotalAssets != null) ? eachData.ReportedTotalAssets.toFixed(2) : ''} crore.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="6">
                        <Accordion.Header>Q7. Is it a good time to buy {getCompName} share? </Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            {getCompName} has a trailing 12-month operating revenue of INR  {(eachData.TotalRevenue != null) ? eachData.TotalRevenue.toFixed(2) : ''} Cr. An annual revenue de-growth of {(eachData.Revenue_Growth != null) ? eachData.Revenue_Growth.toFixed(2) : ''}% requires improvement. A pre-tax margin of {(eachData.PreTaxMargin != null) ? eachData.PreTaxMargin.toFixed(2) : ''}% is healthy, and an ROE of {(eachData.ROE_TTM != null) ? eachData.ROE_TTM.toFixed(2) : ''}% is adequate but could be improved. {getCompName} has a reasonable debt-to-equity ratio of {(eachData.DebttoEquity != null) ? eachData.DebttoEquity.toFixed(2) : ''}%, indicating a healthy balance sheet.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="7">
                        <Accordion.Header>Q8. How to check corporate action in {getCompName} ? </Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            Any one can directly search through Moneysukh. Just type “{getCompName}” in search bar on the top and you will find all the details.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="8">
                        <Accordion.Header>Q9. What is the 52 Week High and Low of {getCompName}? </Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            52 Week High of {getCompName} is {(eachData.BSEhigh52wk != null) ? eachData.BSEhigh52wk.toFixed(2) : ''} and Low is {(eachData.BSElow52wk != null) ? eachData.BSElow52wk.toFixed(2) : ''}.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="9">
                        <Accordion.Header>Q10. How to check the open price and close price of {getCompName} ? </Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            Click on the search box and type the name of the stock you want to search. Select the stock you wish to check. Once you click on the stock name, you will see "Markets" page on your screen. On the top, just above the price chart you will get the {getCompName} High, Low, Open Price and Previous Close Price.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="10">
                        <Accordion.Header>Q11. How to check {getCompName} financial statements and cashflow detailed information? </Accordion.Header>
                        <Accordion.Body className="textjustify">
                          <p>
                            In the “ Market” tab section there are two scroll tabs. Click first tab and select “ company profile”. Now enter company name and select the information required.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                }
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}

export default React.forwardRef(Faq);
